export default __webpack_public_path__ + "static/media/ba17.11e36ee6.jpg";